import api from './config'

import type { User } from '@/types/user'

export interface CreateParams {
  session: {
    email: string
    password: string
  }
}
interface CreateResponse {
  user?: User
  token?: string
}

const sessionsAPI = {
  create: async (data: CreateParams) => {
    const response = await api.post<CreateResponse>('/session', data)
    return response.data
  },

  destroy: async () => {
    await api.delete('/sessions')
  }
}

export default sessionsAPI